import React from 'react';
import type { MutableRefObject, RefObject } from 'react';
import type { PlayerUIState } from '@jwp/ott-player-sdk';
import type shaka from 'shaka-player';

import CustomPlayerChapters from './CustomPlayerChapters';
import SeekBarChapterTooltip from './SeekBarChapterTooltip';
import { useCustomPlayerChapters } from './useCustomPlayerChapters';

type Props = {
  state: PlayerUIState;
  videoRef: RefObject<HTMLVideoElement | null>;
  containerRef: RefObject<HTMLDivElement | null>;
  shakaPlayerRef: MutableRefObject<shaka.Player | null>;
  chaptersUrl: string | null;
  isLiveStream: boolean;
  hidden?: boolean;
};

/** Owns chapter fetch/parsing; wires menu + unified JW-style scrub preview (`getThumbnails` + chapters). */
const CustomPlayerOverlays: React.FC<Props> = ({
  state,
  videoRef,
  containerRef,
  shakaPlayerRef,
  chaptersUrl,
  isLiveStream,
  hidden = false,
}) => {
  if (hidden) return null;
  const vod = !isLiveStream && !state.loadError;
  const chaptersEnabled = vod && Boolean(chaptersUrl);

  const { chapters, activeTitle, activeChapterIndex, seekTo } = useCustomPlayerChapters({
    videoRef,
    chaptersUrl,
    enabled: chaptersEnabled,
  });

  const scrubEnabled = chaptersEnabled && chapters.length > 0;

  return (
    <>
      <SeekBarChapterTooltip
        containerRef={containerRef}
        videoRef={videoRef}
        shakaPlayerRef={shakaPlayerRef}
        chapters={chapters}
        enabled={scrubEnabled}
      />
      {/* <CustomPlayerChapters
        videoRef={videoRef}
        chaptersUrl={chaptersUrl}
        enabled={vod}
        chapters={chapters}
        activeTitle={activeTitle}
        activeChapterIndex={activeChapterIndex}
        seekTo={seekTo}
      /> */}
    </>
  );
};

export default CustomPlayerOverlays;
